import React from 'react';
import s from './Footer.module.css';
import images from '../../assets';

const Footer = () => {
  return (
    <div className="container">
      <div className={s.footer}>
        <a href="#header" className={s.logoWrap}>
          <img src={images.SubtractFooter} alt="logo" />
          <p className={s.SubtractFooterText}>ArtistsHub</p>
        </a>
        <div className={s.bigMenu}>
          <nav>
            <ul className={s.bigMenuList}>
              <li>
                <a href="#artists" className={s.links}>
                  {' '}
                  Artists
                </a>
              </li>
              <li>
                <a href="#about" className={s.links}>
                  {' '}
                  About Us
                </a>
              </li>
              <li>
                <a href="#reviews" className={s.links}>
                  {' '}
                  Reviews
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div className={s.descrWrap}>
          <div className={s.footerDesc}>
            <div className={s.mediaLinks}>
              <svg
                className={s.socials}
                width="40"
                height="41"
                viewBox="0 0 40 41"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.998 8.59019C24.0053 8.59019 24.4796 8.608 26.0553 8.6783C27.5204 8.74298 28.3106 8.98857 28.8384 9.19386C29.5358 9.46382 30.0392 9.7919 30.5603 10.3131C31.0881 10.8408 31.4096 11.3386 31.6852 12.036C31.8905 12.5637 32.1361 13.3596 32.2007 14.819C32.271 16.4013 32.2889 16.8756 32.2889 20.8773C32.2889 24.879 32.271 25.3589 32.2007 26.9356C32.1361 28.4007 31.8905 29.1909 31.6852 29.7186C31.4152 30.416 31.0881 30.9194 30.566 31.4406C30.0382 31.9683 29.5405 32.2898 28.844 32.5654C28.3163 32.7707 27.5195 33.0163 26.0609 33.081C24.4787 33.1513 24.0043 33.1691 20.0027 33.1691C16.001 33.1691 15.5211 33.1513 13.9444 33.081C12.4793 33.0163 11.6891 32.7707 11.1614 32.5654C10.464 32.2955 9.96059 31.9683 9.43847 31.4462C8.91073 30.9185 8.58921 30.4207 8.31362 29.7242C8.10834 29.1965 7.86274 28.3997 7.79806 26.9412C7.72776 25.3589 7.70995 24.8846 7.70995 20.8829C7.70995 16.8813 7.72776 16.4013 7.79806 14.8247C7.86274 13.3596 8.10834 12.5693 8.31362 12.0416C8.58358 11.3442 8.91167 10.8408 9.43285 10.3187C9.96059 9.79096 10.4583 9.46944 11.1557 9.19386C11.6835 8.98857 12.4793 8.74298 13.9388 8.6783C15.5145 8.608 15.9898 8.59019 19.9971 8.59019H19.998ZM19.998 5.88961C15.926 5.88961 15.417 5.90742 13.8169 5.97772C12.2234 6.04803 11.1276 6.3058 10.179 6.67513C9.18913 7.06133 8.35112 7.57126 7.51966 8.40927C6.68165 9.24166 6.17172 10.0787 5.78552 11.063C5.41619 12.0182 5.15842 13.1074 5.08811 14.7009C5.01781 16.3067 5 16.8157 5 20.8876C5 24.9596 5.01781 25.4686 5.08811 27.0687C5.15842 28.6622 5.41619 29.758 5.78552 30.7066C6.17266 31.6965 6.68165 32.5345 7.51966 33.3659C8.35112 34.1974 9.18913 34.7139 10.1734 35.0945C11.1286 35.4638 12.2178 35.7216 13.8113 35.7919C15.4105 35.8622 15.9204 35.88 19.9924 35.88C24.0643 35.88 24.5743 35.8622 26.1734 35.7919C27.767 35.7216 28.8628 35.4638 29.8114 35.0945C30.7956 34.7139 31.6336 34.1983 32.4651 33.3659C33.2965 32.5336 33.813 31.6965 34.1936 30.7122C34.5629 29.757 34.8207 28.6678 34.891 27.0743C34.9613 25.4751 34.9791 24.9652 34.9791 20.8932C34.9791 16.8213 34.9613 16.3123 34.891 14.7122C34.8207 13.1186 34.5629 12.0229 34.1936 11.0742C33.8243 10.0778 33.3143 9.24072 32.4773 8.40834C31.6458 7.57688 30.8078 7.06039 29.8236 6.67982C28.8684 6.31049 27.7791 6.05271 26.1856 5.98241C24.5808 5.90648 24.0709 5.88867 19.9989 5.88867L19.998 5.88961Z"
                  fill="currentColor"
                />
                <path
                  d="M19.9977 13.1831C15.7449 13.1831 12.2935 16.6336 12.2935 20.8874C12.2935 25.1412 15.7439 28.5917 19.9977 28.5917C24.2515 28.5917 27.702 25.1412 27.702 20.8874C27.702 16.6345 24.2515 13.1831 19.9977 13.1831ZM19.9977 25.8845C17.2381 25.8845 15.0006 23.647 15.0006 20.8874C15.0006 18.1278 17.2381 15.8902 19.9977 15.8902C22.7574 15.8902 24.9949 18.1278 24.9949 20.8874C24.9949 23.647 22.7574 25.8845 19.9977 25.8845Z"
                  fill="currentColor"
                />
                <path
                  d="M29.8037 12.8789C29.8037 13.8725 28.9985 14.6777 28.0049 14.6777C27.0113 14.6777 26.2061 13.8725 26.2061 12.8789C26.2061 11.8853 27.0113 11.0801 28.0049 11.0801C28.9985 11.0801 29.8037 11.8853 29.8037 12.8789Z"
                  fill="currentColor"
                />
              </svg>
              <svg
                className={s.socials}
                width="40"
                height="41"
                viewBox="0 0 40 41"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M36.6668 21.395C36.6668 12.134 29.205 4.62646 20.0002 4.62646C10.7954 4.62646 3.3335 12.134 3.3335 21.395C3.3335 29.7645 9.42823 36.7018 17.396 37.9598V26.2421H13.1642V21.395H17.396V17.7007C17.396 13.4981 19.8843 11.1767 23.6912 11.1767C25.5148 11.1767 27.422 11.5042 27.422 11.5042V15.6308H25.3205C23.2502 15.6308 22.6043 16.9235 22.6043 18.2496V21.395H27.2267L26.4878 26.2421H22.6043V37.9598C30.5722 36.7018 36.6668 29.7648 36.6668 21.395Z"
                  fill="currentColor"
                />
              </svg>
              <svg
                className={s.socials}
                width="40"
                height="41"
                viewBox="0 0 40 41"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M35.9889 12.8938C35.799 12.1895 35.4281 11.5472 34.9128 11.0308C34.3976 10.5144 33.7561 10.1419 33.0522 9.95051C30.4422 9.23385 20.0005 9.22218 20.0005 9.22218C20.0005 9.22218 9.56055 9.21051 6.94888 9.89551C6.24542 10.0958 5.60525 10.4735 5.08983 10.9924C4.5744 11.5113 4.20103 12.154 4.00555 12.8588C3.31722 15.4688 3.31055 20.8822 3.31055 20.8822C3.31055 20.8822 3.30388 26.3222 3.98722 28.9055C4.37055 30.3338 5.49555 31.4622 6.92555 31.8472C9.56222 32.5639 19.9755 32.5755 19.9755 32.5755C19.9755 32.5755 30.4172 32.5872 33.0272 31.9038C33.7314 31.7127 34.3735 31.3412 34.89 30.8258C35.4065 30.3105 35.7795 29.6692 35.9722 28.9655C36.6622 26.3572 36.6672 20.9455 36.6672 20.9455C36.6672 20.9455 36.7006 15.5038 35.9889 12.8938ZM16.6606 25.8972L16.6689 15.8972L25.3472 20.9055L16.6606 25.8972Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <p>© 2025 ArtistsHub. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
